import { render, staticRenderFns } from "./UploadRequestResultsAnnotation.vue?vue&type=template&id=6789f1cd&scoped=true"
import script from "./UploadRequestResultsAnnotation.vue?vue&type=script&lang=js"
export * from "./UploadRequestResultsAnnotation.vue?vue&type=script&lang=js"
import style0 from "./UploadRequestResultsAnnotation.vue?vue&type=style&index=0&id=6789f1cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6789f1cd",
  null
  
)

export default component.exports